import { FC, useEffect, useState } from 'react';
import css from './index.module.css';
import Content from '@components/adminNavigation';
import axios from "axios";
import SEO from '@components/seo';
import Popup from '@components/popup';
import { toast } from 'sonner';

export default function Stocks() {
  const [showPopup, setShowPopup] = useState(false);
  const [stocks, setStocks] = useState<any>([]);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_ADM_URL}/stocks`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    }).then(response => {
        setStocks(response.data);
    }).catch(error => {
        console.log(error);
    });
  }, [showPopup]);

  return (
    <Content>
      <CreatePopup showPopup={showPopup} setShowPopup={setShowPopup} />
      <SEO 
        title={'Склады'}
        description={'Админ-панель'}
        ogUrl={`https://рыбныимир.рф/`}
      />

      <h1 className={css.head}>Склады <i className="fi fi-rr-add" onClick={() => setShowPopup(true)}></i></h1>

      <div className={css.table}>
          <div className={css.tableHeader}>
              <a>#</a>
              <a>Название</a>
              <a>Адрес</a>
          </div>

          <div className={css.tableBody}>
            {stocks.map((item: any) => (
              <div className={css.tableDiv}>
                <a>{item.id}</a>
                <a>{item.name}</a>
                <a>{item.address}</a>
              </div>
            ))}
          </div>
      </div>
    </Content>
  );
}


interface PopupInfo {
  showPopup: boolean, 
  setShowPopup: any
}

const CreatePopup: FC<PopupInfo> = ({ showPopup, setShowPopup }) => {
  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    axios.post(`${import.meta.env.VITE_API_ADM_URL}/stocks`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    .then(_ => {
      toast.success('Успешно создано');
      setShowPopup(false);
    })
    .catch(error => {
      console.log(error);
    });
  };
  
  return (
  <Popup showPopup={showPopup} setShowPopup={setShowPopup}>
    <h2>Добавить склад</h2>

    <form onSubmit={handleSubmit}>
      <div className={css.inputGrid}>
        <label>Название</label>
        <input name='name' type='text' placeholder='Название' />
      </div>

      <div className={css.inputGrid}>
        <label>Адрес</label>
        <input name='address' type='text' placeholder='Пароль' />
      </div>

      <button className={css.saveBtn} type='submit'>Добавить новый склад</button>
    </form>
  </Popup>
  )
}